import type { JSX } from 'react';

import { Translate } from '@change-corgi/core/react/i18n';
import { Card } from '@change-corgi/design-system-legacy/components/content';
import { Box } from '@change-corgi/design-system-legacy/layout';
import { Heading } from '@change-corgi/design-system-legacy/typography';

import { useStarterDashboardTabExperiment } from 'src/app/pages/starterDashboardV2/shared/hooks';

import { PetitionStats } from './components/PetitionStats';
import { PetitionStrengthScore } from './components/PetitionStrengthScore';
import { ReachedYourGoal } from './components/ReachedYourGoal';
import { usePetitionOverview } from './hooks/usePetitionOverview';

export function PetitionOverview(): JSX.Element {
	const {
		data: { strengthTipsEnabled },
	} = usePetitionOverview();
	const {
		data: { variant },
	} = useStarterDashboardTabExperiment();

	return (
		<Box as="section" aria-labelledby="petition-overview-title">
			{variant === 'control' && (
				<Heading
					as="h2"
					size={['h4', 'h3']}
					id="petition-overview-title"
					data-qa="petition-overview-title"
					data-testid="petition-overview-title"
				>
					<Translate value="corgi.petition.starter_dashboard.petition_overview.title" />
				</Heading>
			)}
			<Card
				p="20px"
				backgroundColor="white"
				sx={{
					border: 'unset',
					display: 'grid',
					gridTemplateColumns: ['1fr', strengthTipsEnabled ? '2fr 1fr' : '1fr'],
					gridTemplateRows: 'auto 1fr',
					width: '100%',
					borderRadius: 'big',
				}}
			>
				<Box sx={{ position: 'relative' }}>
					<PetitionStats />
				</Box>
				{strengthTipsEnabled && <PetitionStrengthScore />}
				<Box sx={{ gridColumn: '1 / -1' }}>
					<ReachedYourGoal />
				</Box>
			</Card>
		</Box>
	);
}
